const user = {
    user: ''        // 保存当前登录的user
}

export default user